import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const matSnackBar = inject(MatSnackBar);
    const translate = inject(TranslateService);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const excluded: string[] = [];
            if (
                !excluded.length ||
                excluded
                    .map((excluded) => error.url?.includes(excluded))
                    .every((v) => v == false)
            ) {
                matSnackBar.open(
                    error.message ?? translate.instant("SNACKBAR.GENERIC_ERROR"),
                    translate.instant("SNACKBAR.CLOSE"),
                );
            }
            return throwError(() => error);
        }),
    );
};
